// Body load opacity
$(window).on("load",(function(){ 
   $("body").animate({opacity:1},700);   
   
   setTimeout(function() {
	$('.mega-menu__content').removeClass('hide');
	}, 1000);    
}));


$(document).ready(function() {

// Home page featured product slider

/*
 $('.featured-slider').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 800,
   autoplay: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  */
 
 
 // Product page quote slider
  $('.product-quoteslider').slick({
		dots: false,
		infinite: true,
		arrows:true,
		speed: 1000,
		fade:true,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1
  });

  // Home quote slider
  $('.homequote-slider').slick({
		dots: true,
		infinite: true,
		arrows:true,
		speed: 500,
		fade:true,
		autoplay: true,
     adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1
  });
  
  
  
// Product page Full ingredient list 

if ($('.ingredient_list ul li').length > 2) {
  // Code to execute if there are more than 2 li elements
  $("a.full_in").show();
} else {
  $("a.full_in").hide();
}
  
var index = 1;
$('.ingredient_list ul li:gt('+index+')').slideUp();
  
$('.full_in').click(function() {
  $('.ingredient_list ul li:gt('+index+')').slideToggle();
  $(this).toggleClass('active');
}); 





});


//cookie code
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}      
function _fnaccept() {
    setCookie('isvisited','yes',30);
    setCookie('isvisitedpopup','yes',30);
    $("#shopify-section-cookies").fadeOut();
	$("#shopify-section-site_newsletter").fadeOut();
  
}      
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for(var i=0; i<ca.length; i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1);
   if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
}
  return "";
}
 $(function(){
      var isvisited = getCookie("isvisited");
      var isvisitedpopup = getCookie("isvisitedpopup");      
      if (isvisited == null || isvisited=='')  {
        $(window).on('load', function() {
          $("#shopify-section-cookies").fadeIn(); 
		  setTimeout(function(){     
		  $("#shopify-section-site_newsletter").fadeIn(); 
		  }, 1000);
        });
      }   
      $(".cookie_accept").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-cookies").fadeOut();
      });  
	  
	  $(".close_popup").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-site_newsletter").fadeOut();
      });
});
//end cookie 


// FAQ page
$('.faq-box h4').on('click', function () {
	$('.faq-box').find('.faq-rte').stop().slideUp();
	$(this).closest('.faq-box').find('.faq-rte').stop().slideToggle();  	
	$('.faq-box h4').not(this).removeClass('active');
	$(this).toggleClass('active');    
});

// Login popup
$('.header__icon--account, .mo_accountlink').on('click', function () {
	$('.login-box').toggleClass('active-box');
	$('body').toggleClass('overflow-hidden');
	$('.login-hover').toggleClass('active');
	
});
$('.login-hover, .cls_p').on('click', function () {
	$('.login-box').removeClass('active-box');
	$('.login-hover').removeClass('active');
	$('body').removeClass('overflow-hidden');
});


// Product variant dropdown
$('#variant_drop').on('click', function () {
	$('#variant_box variant-radios').slideToggle();
	$(this).toggleClass('active');	
});

$('#variant_box variant-radios label').on('click', function () {
	$('#variant_box variant-radios').slideUp();
	$('#variant_drop').removeClass('active');
	var radiotext = $(this).attr('data-val');
	$('#variant_drop span').html(radiotext);
});


$(document).on("click","#select li a",function() {
//	$("#SortBy").trigger('onchange');
});

$(document).on("click",".open_sortby_drow",function() {
	$("#sort_bylist ul").slideToggle('fast');
   $(this).toggleClass('active');  
});

$("#sort_bylist ul label").on("click", function() {
	$("#sort_bylist ul").slideUp('fast');
   $('.open_sortby_drow').removeClass('active');  
 //  var sorttext = $('.radio-box input:checked').attr('data-name');
//   $('.open_sortby_drow span').html(sorttext); 
 // var reqval = $(this).attr('data-id');
  
 setTimeout(function(){ 
   //var sorttext = $(this).html();
   
  // alert(reqval);
   //$('#SortBy').find('option')[2].trigger('change');
   //$('#SortBy').val(reqval)..trigger('change');
   //$('#SortBy>option:eq(2)').prop('selected', true); 
  // $('#SortBy').val(reqval).change(); 


 }, 1000);
});



  
// Cart drawer add class on scroll down
$(window).scroll(function() {
	    var scroll = $(window).scrollTop();      
	    if (scroll >= 160) {
		$("body").addClass("drawer_up");
	    } else {
		$("body").removeClass("drawer_up");
	    }
	});

// book page model
$(document).on("click",".multi_btn",function() {
	$('.modal').show();
     $("body").addClass("overflow-hidden");
  var iframeurl = $(this).attr('data-url');  
setTimeout(function(){ 
$('#myModal iframe').attr('src', iframeurl);
   }, 200);
  
});

$(document).on("click",".modal .close, .modal-over",function() {
	$('.modal').hide();
     $("body").removeClass("overflow-hidden");
    setTimeout(function(){ 
    $('#myModal iframe').attr('src', '');
    }, 50);
});


$(function () {

  //BEGIN
  $(".template-product .accordion__title").on("click", function (e) {

    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass("accordion-active")) {
      $(".template-product .accordion__content").slideUp(400);
      $(".template-product .accordion__title").removeClass("accordion-active");
      $('.template-product accordion__arrow').removeClass('accordion__rotate');
    }

    $this.toggleClass("accordion-active");
    $this.next().slideToggle();
    $('.template-product .accordion__arrow', this).toggleClass('accordion__rotate');
  });
  //END

});
//# sourceURL=pen.js